/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_Presence_DescInputs */

const en_of_landing_presence_desc = /** @type {(inputs: Of_Landing_Presence_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find teammates by name or room, follow focus cycles, and keep the roster nearby in a compact Mini Mode window.`)
};

const id_of_landing_presence_desc = /** @type {(inputs: Of_Landing_Presence_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari rekan berdasarkan nama atau ruang, ikuti siklus fokus, dan pantau kehadiran melalui jendela Mini Mode yang ringkas.`)
};

/**
* | output |
* | --- |
* | "Find teammates by name or room, follow focus cycles, and keep the roster nearby in a compact Mini Mode window." |
*
* @param {Of_Landing_Presence_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_presence_desc = /** @type {((inputs?: Of_Landing_Presence_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_Presence_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_presence_desc(inputs)
	return en_of_landing_presence_desc(inputs)
});